import classNames from "classnames";
import type { FC } from "react";
import type { Dayjs } from "dayjs";
import type { NoteEvent } from "@/services/api";
import styles from "./styles.module.scss";
import { CalendarEventCard } from "./components";

type CalendarEventListMobileProps = {
  date: Dayjs;
  events: NoteEvent[];
};

export const CalendarEventListMobile: FC<CalendarEventListMobileProps> = ({ events, date }) => {
  return (
    <ul className={classNames(styles["todo-list"])}>
      {events.map((event) => {
        const id = event.noteId;
        return <CalendarEventCard key={id} type={event.type} id={id} currentDate={date} />;
      })}
    </ul>
  );
};
